// src/app/services/order-tracking.service.ts
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { OrderTracking } from '../models/tracking.model';


@Injectable({
  providedIn: 'root'
})
export class OrderTrackingService {
  private apiUrl = 'https://localhost:7224/api/orders'; // adjust base URL

  constructor(private http: HttpClient) { }

  // GET /api/orders/track/{trackingNumber}
  getTracking(trackingNumber: string): Observable<OrderTracking> {
    return this.http.get<OrderTracking>(`${this.apiUrl}/track/${encodeURIComponent(trackingNumber)}`);
  }
}
